<template>
    <div class="container">
        <div class="d-flex flex-column align-items-center text-center p-4">
            <h3 class=" ">Simple and Secure Renting</h3>
            <p class="font2">Your All-in-One Marketplace for Renting with Confidence</p>

            <div class="row w-100 justify-content-around d-flex">
                <div class="col-12 col-md-4 text-center d-flex align-items-center flex-column p-3 mp-width">
                    <img src="@/assets/images/marketplace1.svg" class="img-fluid custom-img" />
                    <h4 class="mt-3 font1">Nationwide properties</h4>
                    <p class="font2">Discover furnished move-in-ready homes available across the 36 states including
                        Ibadan and Calabar</p>
                </div>
                <div class="col-12 col-md-4 text-center d-flex align-items-center flex-column p-3 mp-width">
                    <img src="@/assets/images/marketplace2.svg" class="img-fluid custom-img" />
                    <h4 class="mt-3 font1">Flexible rental payments</h4>
                    <p class="font2">Discover furnished move-in-ready homes available across the 36 states including
                        Ibadan and Calabar</p>
                </div>
                <div class="col-12 col-md-4 text-center d-flex align-items-center flex-column p-3 mp-width">
                    <img src="@/assets/images/marketplace3.svg" class="img-fluid custom-img" />
                    <h4 class="mt-3 font1">Tech that works</h4>
                    <p class="font2">Discover furnished move-in-ready homes available across the 36 states including
                        Ibadan and Calabar</p>
                </div>
            </div>
        </div>
    </div>


</template>
<style>
.font1 {
    font-family: 'CommunityGothicCond';
    font-size: 18px;
    font-weight: 500;
    color: #000000;
}

.font2 {
    font-family: 'CommunityGothic';
    font-size: 12px;
    font-weight: 400;
    color: #7B7B7B;
}

. {
    font-family: 'CommunityGothicCond';
    font-size: 26px;
    font-weight: 600;
    color: #000000;
}

.mp-width {
    width: 280px;
}
</style>
<script>

</script>